module.exports = __webpack_public_path__ + "static/media/ImgPreguntas.b07428b8.png";